import AppService from '../AppService';

class PickService extends AppService {

  constructor() {
    super();
    this.path = this.getPath('pick');
  }

  list(params = '') {
    const queryParams = params ? params : '';
    return this.http.get(`${this.path}${queryParams}`);
  }

  listSearch(search) {
    return this.http.get(`${this.path}?${search}`);
  }
}

export default PickService;
